import { render, staticRenderFns } from "./BulkAddEnglishAssessmentComponent.vue?vue&type=template&id=1973a71a"
import script from "./BulkAddEnglishAssessmentComponent.vue?vue&type=script&lang=js"
export * from "./BulkAddEnglishAssessmentComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports